<!-- 补考安排 -->
<template>
    <!--    {
        "examId": "1597320922551984128",
        "paperId": null,
        "examType": null,
        "examStatus": null,
        "examNo": null,
        "tePlanCourseInfoId": null,
        "invigilateTeacherIds": null,
        "markingTeacherIds": null,
        "examState": 4,
        "examStartTime": null,
        "examEndTime": null,
        "examAddTime": null,
        "userId": null,
        "orgId": null,
        "studentId": "4",
        "infoStartTime": "2022-11-21 00:00:00",
        "tePlanCourseId": "350",
        "courseName": "多媒体技术",
        "infoEndTime": "2022-12-06 00:00:00",
        "examTimeLimit": "60",
        "remainExamCount": 3
    }-->
    <div class="el-makeUpExam">
        <el-row class="page_content">
            <h1 class="head_title">补考安排</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                    prop="courseName"
                    header-align="center"
                    align="center"
                    label="课程名称">
                </el-table-column>
                <el-table-column
                    prop="semestersText"
                    header-align="center"
                    align="center"
                    v-if="!this.$strExistHostnameOnce(['localhost', 'lfjtysxx'])"
                    label="学期">
                </el-table-column>
                <el-table-column
                    prop="examTime"
                    header-align="center"
                    align="center"
                    label="考试时间">
                </el-table-column>
                <el-table-column
                    prop="examTimeLimit"
                    header-align="center"
                    align="center"
                    label="考试时长"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="remainExamCount"
                    header-align="center"
                    align="center"
                    label="考试次数"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="address"
                    header-align="center"
                    align="center"
                    label="开始考试"
                    width="180">
                    <template slot-scope="scope">
                        <template
                            v-if="new Date(scope.row.examTime.substring(0, 19)).getTime() < getNowTime && new Date().getTime() < new Date(scope.row.examTime.substring(20, 39)).getTime()">
                            <el-button type="primary" @click="ksks(scope.$index)" size="mini">开始考试</el-button>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :page-size="limit"
                layout="prev, pager, next"
                :total="count"
                @current-change="pageChange"
            >
            </el-pagination>
        </el-row>
    </div>
</template>
<script>
import {openWithRoleTag} from "../common/ulit";

export default {
    name: "MakeUpExam",
    data() {
        return {
            tableData: [],
            limit: 10,
            count: 100,
            getNowTime: new Date().getTime()
        };
    },
    created() {
        this.getNowDate();
        this.pageChange(1);
    },
    methods: {
        ksks(index) {
            let item = this.tableData[index];
            openWithRoleTag(
                window.location.origin
                + '/MakeUpExamList?tePlanCourseId='
                + item.tePlanCourseId
                + "&courseName="
                + this.$Base64.encode(item.courseName)
            );
        },
        pageChange(num) {
            this.$store.dispatch("user/queryMakeUpExam", {
                limit: this.limit,
                page: num
            }).then((ret) => {
                if (ret.code === 0 || ret.code === '0') {
                    //{
                    this.count = ret.count;
                    this.tableData = ret.data;
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            });
        },
        getNowDate() { //获取服务器当前时间，如果获取失败则获取当前系统时间
            const this_ = this;
            this.$store.dispatch("getNowTime").then((res) => {
                if (res.code == 0) {
                    this.getNowTime = new Date(res.data).getTime();
                } else {
                    this.getNowTime = new Date().getTime();
                }
            }).catch(function (error) {
                this_.getNowTime = new Date().getTime();
            });
        }
        // queryMakeUpExam
    },

};
</script>
<style lang="less">
@import '../styles/base.less';

.el-makeUpExam {
    .wd {
        color: @red;
    }

    .el-dialog__body {
        border-top: 1px solid #ebeef5;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/MakeUpExam.vue